import {
  Component,
  ElementRef,
  ViewChild,
  AfterViewInit,
  OnDestroy,
  inject,
} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { FabricDataService } from '../fabric-data.service';

const optimiseUrl = 'https://data-apps.perse.io?iframe_mode=true';
// const optimiseUrl = 'http://localhost:8501/?iframe_mode=true';

@Component({
  selector: 'app-optimise',
  standalone: true,
  imports: [],
  templateUrl: './optimise.component.html',
  styleUrl: './optimise.component.scss',
})
export class OptimiseComponent implements AfterViewInit, OnDestroy {
  fabricDataService = inject(FabricDataService);

  @ViewChild('optimiseIframe') iframeElement!: ElementRef<HTMLIFrameElement>;
  optimiseUrl: SafeResourceUrl;
  private iframeLoadHandler: (() => void) | null = null;

  constructor(private sanitizer: DomSanitizer) {
    this.optimiseUrl =
      this.sanitizer.bypassSecurityTrustResourceUrl(optimiseUrl);
  }

  ngAfterViewInit(): void {
    // Create and store the load handler
    this.iframeLoadHandler = () => {
      this.postMessageToIframe();
    };

    // Listen for the iframe load event
    const iframe = this.iframeElement.nativeElement;
    iframe.addEventListener('load', this.iframeLoadHandler);

    // Add event listener for messages from iframe (if needed in future)
    // window.addEventListener('message', (event) => {
    //   // Handle messages from iframe if necessary
    //   // console.log('Received message from iframe:', event.data);
    // });
  }

  ngOnDestroy(): void {
    // Clean up event listener
    if (this.iframeLoadHandler && this.iframeElement) {
      const iframe = this.iframeElement.nativeElement;
      iframe.removeEventListener('load', this.iframeLoadHandler);
      this.iframeLoadHandler = null;
    }
  }

  private async postMessageToIframe(): Promise<void> {
    const permissions = await this.fabricDataService
      .getPermissions()
      .toPromise();

    const iframe = this.iframeElement.nativeElement;
    if (iframe.contentWindow && permissions) {
      let message = {
        type: 'STREAMLIT_AUTH_PAYLOAD',
        payload: {
          data: {
            ...permissions,
          },
        },
      };
      // Post message to iframe
      setTimeout(() => {
        if (iframe.contentWindow) {
          iframe.contentWindow.postMessage(message, '*');
          console.log('Posted message to iframe:', message);
        }
      }, 3000);
    }
  }
}
